import type { WhitelabelVariantDefinition } from '../../types';

const tealPrimary = {
  900: '#004D40',
  800: '#00695C',
  700: '#00897B',
  500: '#4DB6AC',
  300: '#80CBC4',
  100: '#E0F2F1',
  contrastText: '#FFFFFF',
} as const;

export const leadzaiTealTheme: WhitelabelVariantDefinition = {
  palette: {
    primary: {
      darker: tealPrimary[900],
      dark: tealPrimary[800],
      main: tealPrimary[700],
      light: tealPrimary[500],
      lighter: tealPrimary[300],
      muted: tealPrimary[100],
      contrastText: tealPrimary.contrastText,
    },
  },
  typography: { fontFamily: 'DM Sans' },
};
